//import Note from "../../models/Note";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "./../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async createNote(context, note) {
      if (note.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/note`,
            data: {
              accountId: note.accountId,
              customerId: note.customerId,
              note: note.note,
              userId: note.userId
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/notes/delete", {
            where: note.tempId
          });
          store.dispatch("entities/notes/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateNote(context, note) {
      if (note.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/note/${note.id}`,
            data: {
              accountId: note.accountId,
              id: note.id,
              customerId: note.customerId,
              note: note.note,
              userId: note.userId
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/notes/update", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/note?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let notes = [];
    obj.forEach(function(note) {
      notes.push({
        accountId: note.accountId,
        id: note.id,
        isDirty: false,
        customerId: note.customerId,
        note: note.note,
        userId: note.userId,
        createdAt: Date.parse(note.createdAt),
        updatedAt: Date.parse(note.updatedAt)
      });
    });
    if (notes.length > 0) {
      store.dispatch("entities/notes/insert", {
        data: notes
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
